export enum OrderStatusDeliveryServiceActionEnum {
    CREATE_COMPANY_NUMBER = 'create_company_number',
}
